module.exports = __webpack_public_path__ + "img/map-location.bc6c0458.png";